import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const Transactions = lazy(() => import('../../container/transactions'));
const View = lazy(() => import('../../container/transactions/View'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/transactions`} component={Transactions} />
      <Route exact path={`${path}/transactions/view/:id`} component={View} />
    </Switch>
  );
}

export default PagesRoute;
